import { fontWeight } from '@cobliteam/ui/theme';
import { css } from 'emotion';

export const mapTypeControl = css`
  display: flex;
  flex-direction: row;
  pointer-events: all;
  margin-bottom: 20px;

  & > button {
    padding: 5.5px 10px;
  }

  & > :not(:first-child) {
    border-left: 0;
  }
`;

export const buttonText = (selected: boolean) => css`
  font-weight: ${selected ? fontWeight.bold : fontWeight.normal};
`;
